<template>
    <section id="statistic" class="detailBooking statistic-section one-page-section">
        <div class="container">
            <div class="row text-center">
                <div class="col-xs-12 col-md-12">
                    <div class="counter">
                        <i class="fa fa-clock-o fa-2x stats-icon"></i>
                        <h2 class="timer count-title count-number">{{date.format('DD-MM-YY')}}</h2>
                        <div class="stats-line-black"></div>
                        <p class="stats-text">{{$t('Date')}}</p>
                    </div>
                </div>
                 <div class="col-xs-12 col-md-12">
                    <div class="counter">
                        <i class="fa fa-code fa-2x stats-icon"></i>
                        <h2 class="timer count-title count-number">{{selectedTime}}
                        </h2>
                        <div class="stats-line-black"></div>
                        <p class="stats-text"> Tee Time</p>
                    </div>
                </div>
                <div class="col-xs-12 col-md-12">
                    <div class="counter">
                        <i class="fa fa-coffee fa-2x stats-icon"></i>
                        <h2 class="timer count-title count-number">{{playersNumber}}</h2>
                        <div class="stats-line-black"></div>
                        <p class="stats-text">{{$t('Players')}}</p>
                    </div>
                </div>
               
               
               
                
              
            </div>
        </div>
    </section>
</template>
    

<style scoped >
 .statistic-section {
     border-radius: 5px; 
     height: 90%;
     padding-top: 70px;
     padding-bottom: 70px;
     background: #2185d0;
}

.count-title {
    font-size: 40px;
    font-weight: normal;
    margin-top: 10px;
    margin-bottom: 0;
	text-align: center;
	font-weight: bold;
    color: #fff;
}

.stats-text {
    font-size: 15px;
    font-weight: normal;
    margin-top: 15px;
    margin-bottom: 0;
    text-align: center;
	color: #fff;
	text-transform: uppercase;
	font-weight: bold;
}

.stats-line-black {
	margin: 12px auto 0;
    width: 55px;
    height: 2px;
    background-color: #fff;
}
.stats-icon {
	font-size: 35px;
	margin: 0 auto;
    float: none;
    display: table;
    color: #fff;
}

@media (max-width: 992px) {
	.counter {
		margin-bottom: 40px;
	}
}

@media only screen and (max-width: 600px) {
  .detailBooking{
        display: none !important;
  }
}


/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .detailBooking{
        display: none !important;
  }
}

</style>

<script>




export default {
  name: 'reservationResume',
  components: {
  
  },
  props:['playersNumber','selectedTime','date'],
  data(){
    return{
 
    }
  },
  computed:{
   
  },
  methods:{
     
  },
  beforeCreate: function() {
    
  }
}

</script>